import IFundsReducer from "../interfaces/IFundsReducer";
import {
  SET_FUNDS_DATA,
  UPDATE_BANK_ACCOUNTS,
  UPDATE_CRYPTO_WALLETS,
  DELETE_CRYPTO_WALLET,
  SET_PURCHASE_EXCHANGE_RATES,
  UPDATE_WALLET_BALANCE_AFTER_TRANSACTION,
  DELETE_BANK_ACCOUNT,
  SET_BANK_FORM_ADDRESS_DATA_AVAILABLE,
  UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION,
} from "./actionTypes";
import { IWalletDetails } from "@market/interfaces/IWallet";
import { AnyAction } from "redux";
import { updateWalletAfterTransaction } from "./helpers/functions";
import { ETransactionType } from "@funds/enums/ETransactionType";
import { IBankAccountProperties } from "@funds/components/WithdrawAmount/IWithdrawAmount";

const initialState: IFundsReducer = {
  supportedUserWallets: undefined,
  bankAccounts: undefined,
  purchaseExchangeRates: undefined,
  cryptoWallets: undefined,
  allUserWallets: undefined,
  pesUserWallets: undefined,
  bankFormAddressDataAvailable: true,
  timestamp: 0,
};

function reducer(state: IFundsReducer = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_FUNDS_DATA:
      return {
        ...state,
        supportedUserWallets: action.payload[0].data.filter(
          (wallet: IWalletDetails) => wallet.supported
        ),
        allUserWallets: action.payload[0].data,
        pesUserWallets: action.payload[3].data,
        bankAccounts: action.payload[1].data.filter(
          (a: IBankAccountProperties) =>
            !["rejected", "expired"].includes(a.status)
        ),
        cryptoWallets: action.payload[2].data,
        timestamp: Date.now(),
      };

    case SET_PURCHASE_EXCHANGE_RATES:
      return {
        ...state,
        purchaseExchangeRates: action.payload.data,
      };

    case SET_BANK_FORM_ADDRESS_DATA_AVAILABLE:
      return {
        ...state,
        bankFormAddressDataAvailable: action.payload,
      };

    case UPDATE_BANK_ACCOUNTS:
      return {
        ...state,
        bankAccounts: state.bankAccounts
          ? [...state.bankAccounts, action.payload.data]
          : [action.payload.data],
      };

    case DELETE_BANK_ACCOUNT:
      return {
        ...state,
        bankAccounts: state.bankAccounts
          ? [...state.bankAccounts.filter((el) => el.id !== action.payload)]
          : [],
      };

    case UPDATE_CRYPTO_WALLETS:
      const walletIdToRemove = action.payload.walletIdToRemove;
      const newCryptoWallets =
        walletIdToRemove && state.cryptoWallets
          ? state.cryptoWallets.filter((el) => el.id !== walletIdToRemove)
          : state.cryptoWallets || [];

      return {
        ...state,
        cryptoWallets: state.cryptoWallets
          ? [...newCryptoWallets, action.payload.data]
          : [action.payload.data],
      };

    case DELETE_CRYPTO_WALLET:
      return {
        ...state,
        cryptoWallets: state.cryptoWallets
          ? [...state.cryptoWallets.filter((el) => el.id !== action.payload)]
          : [],
      };
    case UPDATE_WALLET_BALANCE_AFTER_TRANSACTION:
      const selectedWallet = state.supportedUserWallets!.find(
        (wallet) => wallet.currency === action.payload.currency
      );

      return {
        ...state,
        supportedUserWallets: [
          ...state.supportedUserWallets!.map((wallet: IWalletDetails) => {
            if (wallet.currency === action.payload.currency) {
              return updateWalletAfterTransaction(
                action.payload,
                selectedWallet!
              );
            }
            return wallet;
          }),
        ],
      };

    case UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION:
      const { incomeCurrency, incomeAmount, outcomeCurrency, outcomeAmount } =
        action.payload;

      return {
        ...state,
        supportedUserWallets: state.supportedUserWallets
          ? [
              ...state.supportedUserWallets.map((wallet: IWalletDetails) => {
                if (wallet.currency === incomeCurrency) {
                  return updateWalletAfterTransaction(
                    {
                      type: ETransactionType.tradeIn,
                      amount: incomeAmount,
                      currency: incomeCurrency,
                    },
                    wallet
                  );
                }

                if (wallet.currency === outcomeCurrency) {
                  return updateWalletAfterTransaction(
                    {
                      type: ETransactionType.tradeOut,
                      amount: outcomeAmount,
                      currency: outcomeCurrency,
                    },
                    wallet
                  );
                }

                return wallet;
              }),
            ]
          : state.supportedUserWallets,
      };
    default:
      return state;
  }
}

export default reducer;
